<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>Bestellübersicht</v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 ma-2>
          <v-btn block color="primary" @click="back">Zurück</v-btn>
        </v-flex>
        <v-flex xs2 ma-2>
          <v-btn block color="primary" @click="forwardDialog=true">Bestellen</v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-flex xs4 ma-2>
        <v-btn block color="primary" @click="download">Download Übersicht</v-btn>
      </v-flex>
      <v-layout wrap>
        <v-flex xs12 sm4 md4 lg3 xl2 pa-4>
          <v-treeview
            activatable
            :items="treeview"
            :active.sync="active"
            open-on-click
            transition
            dense
          ></v-treeview>
        </v-flex>

        <v-flex xs12 sm8 md8 lg9 xl10 text-center>
          <v-scroll-y-transition mode="out-in">
            <v-card
              v-if="selected !== undefined && selected.lizenz !== undefined"
              class="pt-6 mx-auto"
              flat
            >
              <v-card-text>
                <h3 class="headline mb-2">Allgemeine Informationen</h3>
                <v-divider></v-divider>
                <v-layout wrap>
                  <v-flex>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>Praxisname:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.praxisName }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Praxisart:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.praxisart }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>ASV-Teams aktiv:</v-list-item-content>
                        <v-list-item-content class="align-end" v-if="selected.asvTeamsAktiv">Ja</v-list-item-content>
                        <v-list-item-content class="align-end" v-else>Nein</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Bemerkung:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.bemerkung }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Manuelle Bestelldokumente vorhanden:</v-list-item-content>
                        <v-list-item-content
                          class="align-end"
                          v-if="selected.manuelleDokumenteLiegenVor"
                        >Ja</v-list-item-content>
                        <v-list-item-content class="align-end" v-else>Nein</v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card
              v-else-if="selected !== undefined && selected.arztrollen !== undefined"
              class="pt-6 mx-auto"
              flat
            >
              <v-card-text>
                <h3
                  class="headline mb-2"
                >{{selected.namensdaten.titel}} {{selected.namensdaten.vorname}} {{selected.namensdaten.nachname}}</h3>
                <v-divider></v-divider>
                <v-layout wrap>
                  <v-flex xs12 md6>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>Anrede:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.namensdaten.anrede }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Nachname:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.namensdaten.nachname }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Titel:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.namensdaten.titel }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Vorname:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.namensdaten.vorname }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Praxisinhaber:</v-list-item-content>
                        <v-list-item-content class="align-end" v-if="selected.praxisinhaber">Ja</v-list-item-content>
                        <v-list-item-content class="align-end" v-else>Nein</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Email:</v-list-item-content>
                        <v-list-item-content
                          class="align-end"
                        >{{ selected.primaereEmailAdresse.email }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Updateverteiler:</v-list-item-content>
                        <v-list-item-content class="align-end" v-if="selected.updateVerteiler">Ja</v-list-item-content>
                        <v-list-item-content class="align-end" v-else>Nein</v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>Aktiv-Ab:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.aktivAb }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Aktiv-Bis:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.aktivBis }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>HZV-Ab:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.hzvAb }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>HZV-Bis:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.hzvBis }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Inaktiv:</v-list-item-content>
                        <v-list-item-content class="align-end" v-if="selected.inaktiv">Ja</v-list-item-content>
                        <v-list-item-content class="align-end" v-else>Nein</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Verkaufspreis:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.verkaufsPreis }}</v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-flex>
                </v-layout>
                <div v-for="rolle in selected.arztrollen" :key="rolle.id">
                  <v-divider></v-divider>
                  <v-layout wrap>
                    <v-flex xs12 md6>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>LANR:</v-list-item-content>
                          <v-list-item-content class="align-end">{{ rolle.lanr }}</v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content>Kürzel:</v-list-item-content>
                          <v-list-item-content class="align-end">{{ rolle.kuerzel }}</v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content>Knappschaftsarzt:</v-list-item-content>
                          <v-list-item-content class="align-end" v-if="selected.knappschaftsarzt">Ja</v-list-item-content>
                          <v-list-item-content class="align-end" v-else>Nein</v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content>Behandlungsorte:</v-list-item-content>
                          <v-list-item-content class="align-end">
                            <v-list dense>
                              <v-list-item
                                v-for="ort in rolle.behandlungsorte"
                                class="pl-0"
                                :key="ort.id"
                              >
                                <v-list-item-content class="align-end">{{ort.name}}</v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-flex>
                    <v-flex xs12 md6 v-if="rolle.asvRollen.length > 0">
                      <v-list dense></v-list>
                      <v-list-item>
                        <v-list-item-content>ASV-Rollen:</v-list-item-content>
                        <v-list-item-content class="align-end">
                          <v-list dense v-for="asv in rolle.asvRollen" class="pl-0" :key="asv.id">
                            <v-list-item>
                              <v-list-item-content>Kürzel:</v-list-item-content>
                              <v-list-item-content class="align-end">{{asv.kuerzel}}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>ASV-Team:</v-list-item-content>
                              <v-list-item-content class="align-end">{{asv.asvTeam.name}}</v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-list-item-content>
                      </v-list-item>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>
            </v-card>
            <v-card
              v-else-if="selected !== undefined && selected.behandlungsortId !== undefined"
              class="pt-6 mx-auto"
              flat
            >
              <v-card-text>
                <h3 class="headline mb-2">{{selected.name}}</h3>
                <v-divider></v-divider>
                <v-layout wrap>
                  <v-flex xs12 md6>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>Name:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.name }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Kürzel:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.kuerzel }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Behandlungsort-ID:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.behandlungsortId }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>BSNR:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.bsnr }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Straße:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.adresse.strasse }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Hausnummer:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.adresse.hausnummer }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Zusatz:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.adresse.adressZusatz }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Postfach:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.adresse.postfach }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>PLZ:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.adresse.plz }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Ort:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.adresse.ort }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Land:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.adresse.land }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Telefonnummer:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.telefonNummer }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Telefax:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.telefax }}</v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>Aktiv-Ab:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.aktivAb }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Aktiv-Bis:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.aktivBis }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Inaktiv:</v-list-item-content>
                        <v-list-item-content class="align-end" v-if="selected.inaktiv">Ja</v-list-item-content>
                        <v-list-item-content class="align-end" v-else>Nein</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Krankenhaus-IK:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.krankenhausIk }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Homepage:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.homepage }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Bisheriges Praxisprogramm:</v-list-item-content>
                        <v-list-item-content
                          class="align-end"
                        >{{ selected.bisherigesPraxisProgramm }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Hauptbehandlungsort:</v-list-item-content>
                        <v-list-item-content
                          class="align-end"
                          v-if="selected.hauptBehandlungsort"
                        >Ja</v-list-item-content>
                        <v-list-item-content class="align-end" v-else>Nein</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Erweiterter Support:</v-list-item-content>
                        <v-list-item-content class="align-end" v-if="selected.erweiterterSupport">Ja</v-list-item-content>
                        <v-list-item-content class="align-end" v-else>Nein</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Verkaufspreis:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.verkaufsPreis }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Datenübernahme aus Konvertierung:</v-list-item-content>
                        <v-list-item-content
                          class="align-end"
                          v-if="selected.datenuebernahmeAusKonvertierung"
                        >Ja</v-list-item-content>
                        <v-list-item-content class="align-end" v-else>Nein</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Email:</v-list-item-content>
                        <v-list-item-content
                          class="align-end"
                        >{{ selected.primaereEmailAdresse.email }}</v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card
              v-else-if="selected !== undefined && selected.kvAbrechnungsgruppeId !== undefined"
              class="pt-6 mx-auto"
              flat
            >
              <v-card-text>
                <h3 class="headline mb-2">{{selected.name}}</h3>
                <v-divider></v-divider>
                <v-layout wrap>
                  <v-flex xs12 md6>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>Name:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.name }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Knappschaftsnummer:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.knappschaftsNummer }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>ID:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.kvAbrechnungsgruppeId }}</v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>Behandlungsorte:</v-list-item-content>
                        <v-list-item-content class="align-end">
                          <v-list dense>
                            <v-list-item
                              v-for="ort in selected.behandlungsorte"
                              class="pl-0"
                              :key="ort.id"
                            >
                              <v-list-item-content class="align-end">{{ort.name}}</v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card
              v-else-if="selected !== undefined && selected.teamId !== undefined"
              class="pt-6 mx-auto"
              flat
            >
              <v-card-text>
                <h3 class="headline mb-2">{{selected.name}}</h3>
                <v-divider></v-divider>
                <v-layout wrap>
                  <v-flex>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>Name:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.name }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Nummer:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.nummer }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>Team-ID:</v-list-item-content>
                        <v-list-item-content class="align-end">{{ selected.teamId }}</v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card v-else class="pt-6 mx-auto" flat>
              <v-card-text>
                <h3 class="headline mb-2">Wählen Sie aus der List ein Objekt zum Betrachten aus</h3>
              </v-card-text>
            </v-card>
          </v-scroll-y-transition>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-dialog v-model="forwardDialog" max-width="600">
      <v-card>
        <v-card-title class="headline">Bestellen</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 pa-1>
                <v-checkbox
                  v-model="controlled"
                  label="Übersicht wurde der Praxis zur Kontrolle vorgelegt"
                  :rules="rules.controlled"
                ></v-checkbox>
              </v-flex>
              <div
                v-if="possiblePraxispartner!== undefined && possiblePraxispartner !== null && possiblePraxispartner.length > 1"
              >Der Praxispartner konnte nicht eindeutig ermittelt werden. Daher muss dieser manuell ausgewählt werden.</div>
              <v-flex xs12 pa-1>
                <v-select
                  v-model="praxisPartner"
                  :items="possiblePraxispartner"
                  label="Praxispartner"
                  item-text="name"
                  return-object
                  :rules="rules.praxisPartner"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="forwardDialog = false">Abbrechen</v-btn>
          <v-btn color="blue darken-1" text @click="forward">Bestellen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendedDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Die Bestellung wurde erfolgreich versendet!</v-card-title>
        <v-card-text>Es kann einige Minuten dauern bis die Bestellung in der Übersicht aktualisiert wird.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="home">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      active: [-1],
      forwardDialog: false,
      sendedDialog: false,
      controlled: false,
      praxisPartner: {
        name: "",
        id: null
      },
      rules: {
        controlled: [
          v =>
            v === true ||
            "Die Übersicht muss der Praxis zur Kontrolle vorgelegt werden"
        ],
        praxisPartner: [
          v => v.id !== null || "Es muss ein Praxispartner ausgewählt werden"
        ]
      }
    };
  },
  computed: {
    ...mapState({
      bestellung: state => state.current.bestellung,
      possiblePraxispartner: state => state.current.possiblePraxispartner
    }),
    treeview() {
      return [
        {
          id: -1,
          name: "Allgemeine Informationen"
        },
        {
          id: "aerzte",
          name: "Ärzte",
          children: this.bestellung.lizenz.aerzte.map(arzt => {
            return {
              id: arzt.id,
              name: arzt.namensdaten.vorname + " " + arzt.namensdaten.nachname
            };
          })
        },
        {
          id: "behandlungsorte",
          name: "Behandlungsorte",
          children: this.bestellung.lizenz.behandlungsorte.map(ort => {
            return {
              id: ort.id,
              name: ort.name
            };
          })
        },
        {
          id: "kvAbrechnungsgruppen",
          name: "KV-Abrechnungsgruppen",
          children: this.bestellung.lizenz.kvAbrechnungsgruppen.map(gruppe => {
            return {
              id: gruppe.id,
              name: gruppe.name
            };
          })
        },
        {
          id: "asvTeams",
          name: "ASV-Team",
          children: this.bestellung.lizenz.asvTeams.map(team => {
            return {
              id: team.id,
              name: team.name
            };
          })
        }
      ];
    },
    selected() {
      if (!this.active.length) return undefined;
      const id = this.active[0];
      const arzt = this.bestellung.lizenz.aerzte.find(arzt => arzt.id === id);
      const behandlunngsort = this.bestellung.lizenz.behandlungsorte.find(
        ort => ort.id === id
      );
      const abrechnungsgruppe = this.bestellung.lizenz.kvAbrechnungsgruppen.find(
        gruppe => gruppe.id === id
      );
      const asvTeam = this.bestellung.lizenz.asvTeams.find(
        team => team.id === id
      );
      if (arzt !== undefined) {
        return arzt;
      } else if (behandlunngsort !== undefined) {
        return behandlunngsort;
      } else if (abrechnungsgruppe !== undefined) {
        return abrechnungsgruppe;
      } else if (asvTeam !== undefined) {
        return asvTeam;
      } else if (id === -1) {
        return this.bestellung;
      }
      return undefined;
    }
  },
  mounted: function() {
    if (
      this.$route.params.process != this.process ||
      this.license === undefined
    ) {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BestellungRequestEvent",
        processId: this.$route.params.process,
        taskId: this.$route.params.task
      });
    }
  },
  updated() {
    if (
      this.possiblePraxispartner !== undefined &&
      this.possiblePraxispartner !== null &&
      this.possiblePraxispartner.length === 1
    ) {
      this.praxisPartner = this.possiblePraxispartner[0];
    }
  },
  methods: {
    download: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.uerbersicht.UebersichtDocumentRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    },
    back: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BackwardRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    },
    forward: function() {
      if (this.$refs.form.validate()) {
        this.forwardDialog = false;
        this.$store.commit("startLoading");
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.order.uerbersicht.UebersichtCompleteRequestEvent",
          taskId: this.$route.params.task,
          processId: this.$route.params.process,
          praxisPartner: this.praxisPartner
        });
        this.sendedDialog = true;
      }
    },
    home: function() {
      this.$router.push("/");
    }
  }
};
</script>
